import React from "react";

const SERVICES = [
  { name: "Private Chef", image: "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=400&h=600&fit=crop" },
  { name: "IV Therapy", image: "https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=400&h=600&fit=crop" },
  { name: "Massage", image: "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=400&h=600&fit=crop" },
  { name: "Restaurant Reservations", image: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=400&h=600&fit=crop" },
  { name: "Airport Transfer", image: "https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?w=400&h=600&fit=crop" },
  { name: "Grocery Delivery", image: "https://images.unsplash.com/photo-1606787366850-de6330128bfc?w=400&h=600&fit=crop" },
];

const MOCK_BOOKINGS = [
  { service: "Private Chef", date: "Mar 15, 2026", status: "confirmed", image: SERVICES[0].image },
  { service: "IV Therapy", date: "Mar 16, 2026", status: "paid", image: SERVICES[1].image },
  { service: "Massage", date: "Mar 17, 2026", status: "pending", image: SERVICES[2].image },
  { service: "Restaurant Reservations", date: "Mar 18, 2026", status: "confirmed", image: SERVICES[3].image },
  { service: "Airport Transfer", date: "Mar 20, 2026", status: "new", image: SERVICES[4].image },
];

const statusColors = {
  confirmed: { bg: "#dcfce7", text: "#16a34a" },
  paid: { bg: "#dbeafe", text: "#2563eb" },
  pending: { bg: "#fef9c3", text: "#ca8a04" },
  new: { bg: "#f3e8ff", text: "#9333ea" },
};

function IPhoneFrame({ children, scale = 1 }) {
  return (
    <div
      style={{
        width: 280 * scale,
        height: 570 * scale,
        borderRadius: 40 * scale,
        border: `8px solid #1a1a1a`,
        background: "#1a1a1a",
        boxShadow: "0 25px 60px rgba(0,0,0,0.3), 0 8px 20px rgba(0,0,0,0.15)",
        overflow: "hidden",
        position: "relative",
        flexShrink: 0,
      }}
    >
      <div
        style={{
          position: "absolute",
          top: 8 * scale,
          left: "50%",
          transform: "translateX(-50%)",
          width: 90 * scale,
          height: 24 * scale,
          background: "#1a1a1a",
          borderRadius: 12 * scale,
          zIndex: 10,
        }}
      />
      <div
        style={{
          width: "100%",
          height: "100%",
          borderRadius: 32 * scale,
          overflow: "hidden",
          background: "#ffffff",
        }}
      >
        {children}
      </div>
    </div>
  );
}

function HomeScreenMockup({ scale = 1 }) {
  const fs = (size) => size * scale;

  return (
    <div style={{ padding: `${fs(40)}px ${fs(16)}px ${fs(12)}px`, height: "100%", overflow: "hidden" }}>
      <div style={{ textAlign: "center", marginBottom: fs(8) }}>
        <div
          style={{
            width: fs(36),
            height: fs(36),
            borderRadius: fs(8),
            background: "linear-gradient(135deg, #667eea, #764ba2)",
            margin: "0 auto",
            marginBottom: fs(4),
          }}
        />
        <div style={{ fontSize: fs(8), fontWeight: 600, color: "#999", letterSpacing: 1.5, textTransform: "uppercase" }}>
          LUXURY STAYS
        </div>
      </div>

      <div style={{ fontSize: fs(20), fontWeight: 800, color: "#1a1a1a", marginBottom: fs(10), letterSpacing: -0.3 }}>
        Hello, Sarah
      </div>

      <div style={{ display: "flex", gap: fs(8), marginBottom: fs(6) }}>
        <div style={{ flex: 1 }}>
          <div style={{ fontSize: fs(7), fontWeight: 700, color: "#999", letterSpacing: 1, textTransform: "uppercase", marginBottom: fs(2) }}>CHECK IN</div>
          <div style={{ fontSize: fs(10), fontWeight: 600, color: "#1a1a1a" }}>Mar 14, 2026</div>
        </div>
        <div style={{ flex: 1 }}>
          <div style={{ fontSize: fs(7), fontWeight: 700, color: "#999", letterSpacing: 1, textTransform: "uppercase", marginBottom: fs(2) }}>CHECKOUT</div>
          <div style={{ fontSize: fs(10), fontWeight: 600, color: "#1a1a1a" }}>Mar 21, 2026</div>
        </div>
      </div>

      <div style={{ fontSize: fs(9), color: "#666", marginBottom: fs(10) }}>
        1234 Ocean Drive Miami FL
      </div>

      <div style={{ height: 1, background: "rgba(0,0,0,0.06)", marginBottom: fs(10) }} />

      <div style={{ fontSize: fs(14), fontWeight: 700, color: "#1a1a1a", marginBottom: fs(10), letterSpacing: -0.2 }}>
        Concierge Services
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: fs(8) }}>
        {SERVICES.slice(0, 4).map((svc) => (
          <div
            key={svc.name}
            style={{
              borderRadius: fs(16),
              overflow: "hidden",
              height: fs(70),
              position: "relative",
              flexShrink: 0,
            }}
          >
            <img
              src={svc.image}
              alt={svc.name}
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
              loading="lazy"
            />
            <div
              style={{
                position: "absolute",
                inset: 0,
                background: "linear-gradient(transparent, rgba(0,0,0,0.1), rgba(0,0,0,0.6))",
                display: "flex",
                alignItems: "flex-end",
                padding: `${fs(8)}px ${fs(10)}px`,
              }}
            >
              <span style={{ color: "#fff", fontWeight: 800, fontSize: fs(13), letterSpacing: -0.3 }}>
                {svc.name}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

function BookingsScreenMockup({ scale = 1 }) {
  const fs = (size) => size * scale;

  return (
    <div style={{ padding: `${fs(40)}px ${fs(16)}px ${fs(12)}px`, height: "100%", overflow: "hidden" }}>
      <div style={{ fontSize: fs(20), fontWeight: 800, color: "#1a1a1a", marginBottom: fs(14), letterSpacing: -0.3 }}>
        Bookings
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: fs(8) }}>
        {MOCK_BOOKINGS.map((b, i) => {
          const sc = statusColors[b.status] || statusColors.new;
          return (
            <div
              key={i}
              style={{
                borderRadius: fs(16),
                overflow: "hidden",
                height: fs(80),
                position: "relative",
                flexShrink: 0,
              }}
            >
              <img
                src={b.image}
                alt={b.service}
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
                loading="lazy"
              />
              <div
                style={{
                  position: "absolute",
                  inset: 0,
                  background: "linear-gradient(transparent, rgba(0,0,0,0.15), rgba(0,0,0,0.65))",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-end",
                  padding: `${fs(8)}px ${fs(10)}px`,
                }}
              >
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end" }}>
                  <div>
                    <div style={{ color: "#fff", fontWeight: 700, fontSize: fs(12), marginBottom: fs(2) }}>
                      {b.service}
                    </div>
                    <div style={{ color: "rgba(255,255,255,0.8)", fontSize: fs(8) }}>{b.date}</div>
                  </div>
                  <span
                    style={{
                      background: sc.bg,
                      color: sc.text,
                      fontSize: fs(7),
                      fontWeight: 700,
                      padding: `${fs(2)}px ${fs(6)}px`,
                      borderRadius: fs(8),
                      textTransform: "capitalize",
                    }}
                  >
                    {b.status}
                  </span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export function IPhoneHomeScreen({ scale = 1 }) {
  return (
    <IPhoneFrame scale={scale}>
      <HomeScreenMockup scale={scale} />
    </IPhoneFrame>
  );
}

export function IPhoneBookingsScreen({ scale = 1 }) {
  return (
    <IPhoneFrame scale={scale}>
      <BookingsScreenMockup scale={scale} />
    </IPhoneFrame>
  );
}

export default function IPhoneMockupPair({ scale = 1 }) {
  return (
    <div style={{ display: "flex", gap: 32, justifyContent: "center", alignItems: "center" }}>
      <div style={{ transform: "rotate(-3deg)" }}>
        <IPhoneHomeScreen scale={scale} />
      </div>
      <div style={{ transform: "rotate(3deg)" }}>
        <IPhoneBookingsScreen scale={scale} />
      </div>
    </div>
  );
}
